import Home from "src/views/Home"

const HomePage: React.FC = () => {
    return (
        <Home />
    )
}

export default HomePage